import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";

import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {usersEdit_template} from "../components/templates/usersEdit_template";
import {header} from "./header";
import {now} from "@amcharts/amcharts4/.internal/core/utils/Time";
import EmbedHelper from "../utils/EmbedHelper";



declare var ko: any;
declare var page: any;
declare var CKEDITOR: any;

let bioEditor;

export class users_edit extends vnModule_knockoutJS {

    public XHRHdl: XMLHttpRequestHandler;
    protected tagsSuggestionsXhr: XMLHttpRequestHandler;
    protected editForm: usersEdit_template;
    protected _isLeavePageWarningNeeded: boolean = true;
    protected embedHelper: EmbedHelper;
    protected currentUserBrandInfo

    /**
     * Embedder expects the caller to have the onGenerateEmbedRequestReturn and getIdBrand functions defined.
     *
     * @param id
     * @param viewModel
     * @param caller
     */
    constructor(vnAppZone) {
        super(vnAppZone);
        this.embedHelper = new EmbedHelper(this);
    }

    protected getModuleName() {
        return "users_edit";
    }

    buildContent(): Array<Element> {

        // create validation errors list template

        // create the users form
        this.editForm = new usersEdit_template("editForm", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("User Form");

        return [this.editForm.build()];
    }

    fillPage(): void {

        this.getFormData();
    }

    protected saveEditUser() {

        this.save();
    }

    public getIdBrand(): number|null
    {
        if (!this.editForm) {
            return null;
        }
        return !!this.editForm.getTemplateViewModel().selectedBrandInfo ? this.editForm.getTemplateViewModel().selectedBrandInfo().brand.id : null;
    }

    protected validateCompanyChange(){

        this.loadingIn(this.editForm.builtTemplate);

        let usrReq_url: string = '/api/user/changeCompany/';
        let usrReq_params: Array<Array<string>> = [];

        usrReq_params.push(["idUser", this.editForm.getTemplateViewModel().idUser()]);
        usrReq_params.push(["idCompany", this.editForm.getTemplateViewModel().idCompany()]);

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.companyChangeReturn;
        this.XHRHdl.execute();
    }

    protected companyChangeReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                obj.editForm.changeCompany();
                obj.editForm.getTemplateViewModel().oldIdCompany(obj.editForm.getTemplateViewModel().idCompany());
            });

            if(req.request.status != 200 && obj.editForm.getTemplateViewModel().idCompany() != obj.editForm.getTemplateViewModel().oldIdCompany()){

                obj.editForm.getTemplateViewModel().idCompany(obj.editForm.getTemplateViewModel().oldIdCompany());
            }

            obj.loadingOut(obj.editForm.builtTemplate);
        }
    }

    public cancelForm() {
        this.cancelEditUser();
    }

    protected cancelEditUser() {

        this.releaseLock();

        // redirect to earnings page or user list
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "User action canceled !");

        let lastRoute = this.getVnAppZone().app.getLastRoute();
        page.redirect(lastRoute);
    }

    protected releaseLock() {
        // request a lock release
        let usrReq_url: string = '/api/user/release/lock_edit/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", this.getVnAppZone().app.params.id]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.execute();
    }

    protected showCountryMessage() {
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "Contact your system administrator to edit your country");
        this.getVnAppZone().showNotificationToModule();
    }

    //
    // obtain the dynamic data required to fill the formulary
    protected getFormData() {
        this.loadingIn(this.editForm.builtTemplate);

        let id: number;

        if ((id = this.getVnAppZone().app.params.id) && !isNaN(id)) {
            this.editForm.getTemplateViewModel().idUser(id);
        }

        let usrReq_url: string = '/api/user/data/' + id + "/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.editForm.getViewModelForRequest())]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }

    //
    // use the form data to fill the form
    protected onGetFormDataReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);

                obj.editForm.setPermissions(responseParsed.data.userPermissions);

                if (obj.getVnAppZone().getGlobal('userEditTab')) {

                    let tab = obj.getVnAppZone().getGlobal('userEditTab');

                    if (tab == "rates" && responseParsed.data.userPermissions['users_form_rates'] && responseParsed.data.userPermissions['users_form_rates'].read) {

                        obj.editForm.onClickShowUserRatesTab();
                    }

                    obj.getVnAppZone().removeGlobal("userEditTab");
                }

                obj.editForm.setSocialMediaFilterItems();

                obj.editForm.setupForm(responseParsed.data);

                obj.initializeCkEditors(responseParsed.data.brandInfo);

                obj.editForm.buildDatePickerCalendar();

                obj.loadingOut(obj.editForm.builtTemplate);
            })
        }
    }

    protected save() {

        this.loadingIn(this.editForm.builtTemplate);

        let formReq_url: string = '/api/user/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.editForm.getViewModelForRequest()));
        subViewModel["editForm"].options_currencies = null;
        subViewModel["editForm"].brands = null;
        subViewModel["editForm"].roles = null;
        subViewModel["editForm"].userPreferences = this.getUserPreferences(subViewModel["editForm"]);

        let brandInfo = subViewModel["editForm"].brandInfo;

        brandInfo = this.getCkeDataToSave(brandInfo);

        for(let b of brandInfo){

            b.user = null;
        }

        subViewModel["editForm"].brandInfo = brandInfo;

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {
                    let responseParsed = JSON.parse(req.request.response);

                    obj.releaseLock();

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "User saved successfully !");

                    // Obtain the header module to change the image and name
                    if ((<users_edit>obj).getVnAppZone().app.loggedUser.user.id == responseParsed.data.id) {
                        let zoneMenu = obj.getVnAppZone().app.getZoneByName("Menu");
                        obj.getVnAppZone().app.loggedUser.user = responseParsed.data;
                        obj.handleSiteMessageDisplay(responseParsed.data.valnet_user.state);
                        zoneMenu.loadedModule.menu.setUser(obj.getVnAppZone().app.loggedUser);
                        zoneMenu.loadedModule.menu.setBrands(obj.getVnAppZone().app.loggedUser.user.brands);
                    }

                    let lastRoute = obj.getVnAppZone().app.getLastRoute();
                    page.redirect(lastRoute);
                })
                obj.loadingOut(obj.editForm.builtTemplate);

            }
        });
        XHRHdl.execute();
    }

    public handleSiteMessageDisplay(state): void {
        let newState = String(state).trim();
        if (newState.length > 0) {
            document.body.removeAttribute('data-message');
        }
    }

    public getUserPreferences(editForm){

        let userPreferences = {};

        userPreferences["spellcheck"] = (editForm.spellcheck == "1");

        return userPreferences;
    }

    public filterSingleDateOnChange(idElement){

        if(idElement = "effectiveDatePicker"){

            //validate that the date is not in the past.
            let selectedDateString = this.editForm.getTemplateViewModel().effectiveDatePicker.singleDatePicker();
            let selectedDate = new Date(selectedDateString);

            let currentDate = now();
            currentDate.setHours(0,0,0,0);

            if(selectedDate < currentDate){

                //Throw some kind of error message here

                this.editForm.setDefaultDate();
            }
        }
    }

    protected initializeCkEditors(brandInfo) {

        for(let name in CKEDITOR.instances)
        {
            CKEDITOR.instances[name].destroy(true);
        }

        if (!CKEDITOR.stylesSet.registered.my_styles) {
            CKEDITOR.stylesSet.add('my_styles', [
                // Block-level styles.
                {name: 'Heading 1', element: 'h1'},
                {name: 'Heading 2', element: 'h2'},
                {name: 'Heading 3', element: 'h3'},
                {name: 'Preformatted', element: 'pre'},
                // Inline styles.
                {name: 'Related: One link', element: 'span', attributes: {'class': 'related-single'}},
                {name: 'Next - One link', element: 'span', attributes: {'class': 'next-single'}},
                {name: 'Affiliate - One link', element: 'span', attributes: {'class': 'affiliate-single'}},
                {name: 'Spoiler Alert', element: 'span', attributes: {'class': 'article-alert'}},
                {name: 'Tip', element: 'div', attributes: {'class': 'emaki-custom tip'}},
                {name: 'Warning', element: 'div', attributes: {'class': 'emaki-custom warning'}},
                {name: 'Note', element: 'div', attributes: {'class': 'emaki-custom note'}},
                {name: 'Expandable', element: 'div', attributes: {'class': 'emaki-custom expandable'}},
                {name: 'Pullquote', element: 'div', attributes: {'class': 'emaki-custom pullquote'}},
            ]);
        }


        CKEDITOR.on('dialogDefinition', function (ev) {
            var dialogName = ev.data.name;
            var dialogDefinition = ev.data.definition;

            //remove features from table dialog
            if (dialogName == 'table') {

                // Get the advanced tab reference
                var infoTab2 = dialogDefinition.getContents('advanced');

                //Set the default
                // Remove the 'Advanced' tab completely
                dialogDefinition.removeContents('advanced');

                // Get the properties tab reference
                var infoTab = dialogDefinition.getContents('info');

                // Remove unnecessary bits from this tab
                /// infoTab.remove('txtBorder');
                infoTab.remove('cmbAlign');
                infoTab.remove('txtWidth');
                infoTab.remove('txtHeight');
                // infoTab.remove('txtCellSpace');
                //infoTab.remove('txtCellPad');
                infoTab.remove('txtCaption');
                infoTab.remove('txtSummary');
            }

            if (dialogName == 'link') {

                /* Getting the contents of the Target tab */

                var targetTab = dialogDefinition.getContents('target');
                var informationTab = dialogDefinition.getContents('info');
                var advancedTab = dialogDefinition.getContents('advanced');

                //remove the browse server button
                informationTab.remove('browse')

                //moving the target dropdown to the main tab
                var targetField = targetTab.get('linkTargetType');

                targetTab.remove('linkTargetType');
                informationTab.add(targetField);

            }
        });

        //Brand CKEs
        brandInfo.forEach((element) => {

            if(element.isAuthorDetailActive()){

                this.initCkEditor('bio-' + element.brand.id);

                for(let i = 1; i < 4; i++){

                    let currentAuthorInfo = document.getElementById("authorInfo-" + i + "-" + element.brand.id);
                    if(currentAuthorInfo){

                        this.initCkEditor("authorInfo-" + i + "-" + element.brand.id);
                    }else{

                        break;
                    }
                }
            }
        });
    }

    protected initCkEditor(idElement) {

        let height, toolbarMA;
        let disallowedContent = 'p';
        //contextmenu,tabletools,tableselection
        let removePlugins = 'elementspath,liststyle,image,forms';

        disallowedContent += ',ul,ol,li';
        removePlugins+= ',list';
        //toolbarMA = [[ 'Source','Undo', 'Redo', 'RemoveFormat', '-', 'Link', 'Unlink', '-',  'SpecialChar', 'Bold', 'Italic', 'Strike', '-', 'LinkBtn', 'Maximize']];
        toolbarMA = [[ 'Source', 'Link', 'Unlink', 'Bold', 'Italic']];
        height = '140px';

        CKEDITOR.replace(idElement, {
            height: height,
            toolbar: 'MA',
            fillEmptyBlocks: false,
            extraAllowedContent: 'img(*){*}[*];div(*){*}[*];pre(*){*}[*];code(*){*}[*];a[rel];a[target];a[href];a[title];a(*);*[id];blockquote(*){*}[*];iframe(*){*}[*];p(*){*}[*];script(*){*}[*];section(*){*}[*]',
            disallowedContent: disallowedContent,
            removePlugins: removePlugins,
            stylesSet: 'my_styles',
            format_tags: "p;h1;h2;h3",
            format_p: {
                element: 'p'
            },
            toolbar_MA : toolbarMA
        });

        CKEDITOR.config.enterMode = CKEDITOR.ENTER_BR;
        CKEDITOR.config.contentsCss = [CKEDITOR.getUrl('contents.css'), '/css/cke_style_short.css?v=5.4'];
        CKEDITOR.config.skin = "n1theme";
        //CKEDITOR.config.extraPlugins = "wordcount,notification,openlink";
        CKEDITOR.config.forcePasteAsPlainText = false;

        // CKEDITOR.on('instanceReady', function () {
        //     CKEDITOR.on('dialogDefinition', function (ev) {
        //         var editor = ev.editor;
        //         editor.dataProcessor.htmlFilter.addRules({
        //             elements: {
        //                 a: function (element) {
        //                     if (!element.attributes.rel){
        //                         element.attributes.rel = 'nofollow';
        //                     }else if(element.attributes.rel.indexOf("nofollow") == -1){
        //                         element.attributes.rel = 'nofollow ' + element.attributes.rel;
        //                     }
        //                 }
        //             }
        //         });
        //     });
        // });

        // CKEDITOR.config.wordcount = {
        //     // Whether or not you want to show the Paragraphs Count
        //     showParagraphs: false,

        //     // Whether or not you want to show the Word Count
        //     showWordCount: true,

        //     // Whether or not you want to show the Char Count
        //     showCharCount: true,

        //     //include spaces
        //     countSpacesAsChars: true,

        //     countLineBreaks: true
        // }
    }

    protected getCkeDataToSave(brandInfo){

        for(let i in CKEDITOR.instances){

            let editor = CKEDITOR.instances[i];
            let editorData = editor.getData();
            let editorName = editor.name;

            //Split the string to get the definition of the cke
            let splitString = editorName.split("-");

            //Get the type (either 'bio' or 'authorInfo')
            let editorType = splitString[0];
            let editorIdBrand = 0;
            let editorIndexAuthorInfo = "0";

            switch(editorType){

                case "bio":
                    editorIdBrand = splitString[1];
                    break;
                case "authorInfo":
                    editorIndexAuthorInfo = splitString[1];
                    editorIdBrand = splitString[2];
                    break;
                default:
                    editorIdBrand = 0;
                    break;
            }

            //In case new cke's get added that don't fall under this
            if(editorIdBrand == 0){

                continue;
            }

            for(let b of brandInfo){

                if(b.brand.id == editorIdBrand){

                    switch(editorType){

                        case "bio":

                            b.bio = editorData;
                            break;

                        case "authorInfo":

                            switch(editorIndexAuthorInfo){

                                case "1":

                                    b.authorInfo1 = editorData;
                                    break;
                                case "2":

                                    b.authorInfo2 = editorData;
                                    break;
                                case "3":

                                    b.authorInfo3 = editorData;
                                    break;
                            }
                            break;
                    }
                    break;
                }
            }
        }

        return brandInfo;
    }

    protected filterMultipleSelectorOnChange(){
        //Show or hide field
        this.editForm.getTemplateViewModel().socialMedia(this.editForm.getViewModelForRequest().editForm.socialMedia());

        if(this.editForm.getTemplateViewModel().website2()){

            this.editForm.getTemplateViewModel().isWebsite2Visible(true);
            if(this.editForm.getTemplateViewModel().website3()){

                this.editForm.getTemplateViewModel().isWebsite3Visible(true);
            }
        }
    }

    protected getArticlesSuggestion(keyword, idElement) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        let subViewModel = {
            list: {keyword: keyword},
            idElement: idElement,
            isSubContent: false,
            idAuthor: this.editForm.getTemplateViewModel().idUser,
            allContributions : true,
        };

        let idBrand = null;
        if(this.editForm.getTemplateViewModel().selectedBrandInfo){
            idBrand = this.editForm.getTemplateViewModel().selectedBrandInfo().brand.id;
        }

        if(!idBrand){
            return;
        }

        let usrReq_url: string = '/api/brand/' + idBrand + "/search/article/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetArticlesSuggestionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetArticlesSuggestionsReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);

                if (response.data.articles) {
                    let articles = [];
                    for(let article of response.data.articles){

                        article.name = article.title;
                        articles.push(article);
                    }

                    obj.editForm.setArticleFilterAutocomplete(articles);
                }
            });
        }
    }

    public filterSimpleOnChange(idElement){
        //Do nothing
    }

    public triggerNotification(message: string): void {
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, message);
        this.getVnAppZone().showNotificationToModule();
    }

    protected generateEmbed(source){

        if (!this.getIdBrand()) {
            return;
        }
        this.loadingIn(this.editForm.builtTemplate);
        this.embedHelper.setIdBrand(this.getIdBrand());

        this.embedHelper.generateEmbed(
            source,
            this.editForm.getTemplateViewModel().embedder.embedType(),
        );

    }

    public onGenerateEmbedRequestReturn(req, obj){

        return function () {

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    obj.editForm.setEmbedData(responseParsed.data);
                }else{
                    obj.editForm.getTemplateViewModel().embedder.embedErrors(responseParsed);
                }
            }

            obj.loadingOut(obj.editForm.builtTemplate);
        }
    }

    protected addEmbedCodeToPage(value){

        let selectedBrandInfo = this.editForm.getTemplateViewModel().selectedBrandInfo();

        if(selectedBrandInfo){
            if (typeof selectedBrandInfo.embeds != "function") {

                selectedBrandInfo.embeds = ko.observableArray(selectedBrandInfo.embeds || []);
            }
            let embeds = selectedBrandInfo.embeds();

            //if there are already 2 articles, do not allow to add more
            if (embeds.length < 2) {

                embeds.push(value);
                selectedBrandInfo.embeds(embeds);
            } else {
                this.triggerNotification('Cannot add more than 2 embeds. Please remove an existing one before adding another.');
                return;
            }

            this.editForm.getTemplateViewModel().selectedBrandInfo(selectedBrandInfo);
            this.editForm.getTemplateViewModel().onClickCloseEmbeds(false);
            this.editForm.getTemplateViewModel().embedder.resetEmbedPopUp();
        }
    }

    public abortEmbedGeneration(): void {
        this.embedHelper.abortEmbedGeneration();
    }

    public getSuggestions(keyword, idElement){
        if(idElement.match(/^filterAutoComplete_/i)) {
            const brandId = idElement.match(/\d+/)[0];
            const brandInfos = this.editForm.getTemplateViewModel().brandInfo()
            const userBrandInfo = this.getUserBrandInfoByBrandId(brandInfos, brandId)
            this.setCurrentUserBrandInfo(userBrandInfo)
            this.getTagsSuggestions(keyword, brandId, idElement)

        }

    }

    private getUserBrandInfoByBrandId(brandInfos : any , idBrandInfo : number){
        return brandInfos.find(({brand}) => brand.id == idBrandInfo)
    }

    protected onAutocompleteInputClick(idElement){
        if(idElement.match(/^filterAutoComplete_/i)) {
            //Do nothing for the moment
        }
    }

    private getTagsSuggestions(keyword, brandId, idElement){
        if(this.tagsSuggestionsXhr){
            this.tagsSuggestionsXhr.cancelAndReset()
        }

        const url = `/api/brand/${brandId}/search/tag/`
        const subViewModel = {
            filter: {
                keyword: keyword,
                limit : 25,
                idTagType: null,
                getSelectable : true,
                getNonSelectable : true,
                imageAndSpecSelectable: false
            },
        };

        let params: Array<Array<string>> = [];
        params.push(["data", ko.toJSON(subViewModel)]);
        this.tagsSuggestionsXhr = new XMLHttpRequestHandler(url, params, this);

        this.tagsSuggestionsXhr.onReadyStateFunction = this.onGetTagSuggestionReturn;
        this.tagsSuggestionsXhr.execute();

    }

    protected onGetTagSuggestionReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                const response = JSON.parse(req.request.response);
                const { data: { tags = [] } } = response;
                const minimalTags = tags ?
                    tags.map(({ id, name, slug, isSelectable }) => ({ id, name, slug, isSelectable })) : [];

                const currentUserBrandInfo = obj.getCurrentUserBrandInfo()
                const topicExpertiseFilterAutoComplete = currentUserBrandInfo.topicExpertise
                topicExpertiseFilterAutoComplete.setOptions(minimalTags)
            });
        }
    }

    protected getCurrentUserBrandInfo(){
        return this.currentUserBrandInfo
    }

    protected setCurrentUserBrandInfo(brandInfo){
        this.currentUserBrandInfo = brandInfo;
    }

    protected onAutocompleteOptionChange(idElement) {
        if(idElement.match(/^filterAutoComplete_/i)) {

            const brandId = idElement.match(/\d+/)[0];
            const brandInfos = this.editForm.getTemplateViewModel().brandInfo()
            const userBrandInfo = this.getUserBrandInfoByBrandId(brandInfos, brandId)
            this.setCurrentUserBrandInfo(userBrandInfo)

            const currentUserBrandInfo = this.getCurrentUserBrandInfo()
            const topicExpertiseFilterAutoComplete = currentUserBrandInfo.topicExpertise
            const selectedTopicExpertiseObject = topicExpertiseFilterAutoComplete.getOptionObj()
            if(currentUserBrandInfo.topicExpertiseList().findIndex(te => te.id == selectedTopicExpertiseObject.id) == -1){
                userBrandInfo.topicExpertiseList.push(selectedTopicExpertiseObject)
            }
            topicExpertiseFilterAutoComplete.clearSelectedOption()
            topicExpertiseFilterAutoComplete.setIsGlobalLockEnabled(currentUserBrandInfo.topicExpertiseMaxItemReached())
        }
    }

    protected onAutocompleteInputClear(idElement): any {
        //Do nothing for now
    }
}



// WEBPACK FOOTER //
// ./js/modules/users_edit.ts